<template>
    <div class="flex">
        <button type="button" class="btn btn-default btn-number remove-product" data-type="minus" @click="decrement" :disabled="quantity <= min">
            <span class="glyphicon glyphicon-minus"></span>
        </button>
        <input class="form-control input-number space-bottom-0 h-full" type="number" :min="min" :max="max" v-model.number="quantity">
        <button type="button" class="btn btn-default btn-number add-product" data-type="plus" @click="increment" :disabled="quantity >= max || maxedOut">
            <span class="glyphicon glyphicon-plus"></span>
        </button>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import { cableSelectionRequiredOfferings } from "../../settings";
    import product from '../../store/modules/product/index';

    export default {
        props: {
            max: {
                type: Number,
            },
            min: {
                type: Number,
                default: 0
            },
            default: {
                type: Number,
            },
            maxedOut: {
                type: Boolean,
                default: false
            },
            productKeyOverride: {
                type: String,
                default: false
            },
            renewalFlow: {
                type: Boolean,
                default: false
            },
            value: {
                type: Object,
                default: () => {}
            }
        },

        data() {
            return {
                quantity: this.default,
            }
        },
        computed: {
            ...mapGetters([
                "activeProductKey",
                "activeOfferKey",
            ]),

            doesOfferRequireCable() {
                return this.activeProductKey in cableSelectionRequiredOfferings
                ? cableSelectionRequiredOfferings[this.activeProductKey].includes(
                    this.activeOfferKey
                )
                : false;
            },
        },
        methods: {
            increment: function () {
                let maxExceeded = (this.quantity + 1) > this.max;
                if (!maxExceeded) {
                    this.quantity++;
                }
            },

            decrement: function() {
                if (this.quantity > this.min) {
                    this.quantity--;
                }
            },

            reset() {
                this.quantity = 0;
            },

            setCablesNeededCount(quantity) {
                return this.$store.commit(
                    `${this.activeProductKey}${this.activeOfferKey}CableSelection/base/setCablesNeededCount`,
                    quantity
                );
            },

            handleMaxLimit(selectedQuantity) {
                if (selectedQuantity === this.max || this.quantity === this.max) {
                    this.$emit('max-exceeded');
                } else {
                    this.$emit('max-exceeded', true);
                }
            }
        },
        watch: {
            quantity(selectedQuantity) {
                if(this.renewalFlow){
                    this.$emit('input', selectedQuantity)
                }
                else{
                    this.quantity = Math.abs(this.quantity);

                    // Handle resetting to the max if a customer enters a larger amount
                    if (this.quantity > this.max || selectedQuantity > this.max) {
                        this.quantity = Math.abs(this.max);
                        selectedQuantity = Math.abs(this.max);
                    }

                    // Emit error message trigger when max is hit / exceeded
                    this.handleMaxLimit(selectedQuantity)
                    
                    // Create the module in the vue store if it doesnt exist
                    if (!this.$store.getters[`${this.productKeyOverride ? this.productKeyOverride : this.activeProductKey}/quantity`]) {
                        this.$store.registerModule(`${this.productKeyOverride ? this.productKeyOverride : this.activeProductKey}`, product)
                    }
                    
                    // Update the quantity of the given product
                    this.$store.commit(`${this.productKeyOverride ? this.productKeyOverride : this.activeProductKey}/setQuantity`, Math.abs(selectedQuantity));
                    
                    // Set cable count if needed
                    if (this.doesOfferRequireCable) {
                        this.setCablesNeededCount(Math.abs(selectedQuantity))
                    }
                    
                    // Pass the change back for triggers or watchers
                    this.$emit('setProductQuantity', Math.abs(selectedQuantity), this.productKeyOverride ? this.productKeyOverride : this.activeProductKey)
                }
            }
        }
    }
</script>

<style scoped>

    .flex {
        display: flex;
    }

    .flex button:disabled {
        border: 1px solid #EEEEEE;
        background-color: #F6F7F9;
    }

    .flex button:disabled span {
        color: #C1C9D1;
    }

    .flex button[disabled] {
        border: 1px solid #EEEEEE;
        background-color: #F6F7F9;
    }

    .flex button[disabled] span {
        color: #C1C9D1;
    }

    .form-control {
        box-shadow: none;
    }

    .input-number {
        text-align: center;
        border: 1px solid #f0f0f0;
        min-width: 40px;
        max-width: 50px;
        padding: 5px;
    }

    .remove-product {
        background-color: #0384fb;
        margin-right: 10px;
    }

    .remove-product span {
        color: white;
    }

    .add-product {
        background-color: #0384fb;
        margin-left: 10px;
        border: none;
    }

    .glyphicon {
        top: 2px;
    }

    .glyphicon-plus {
        left: 1px;
    }

    .glyphicon-minus {
        color: #C1C9D1;
        right: 1px;
    }
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type=number] {
        -moz-appearance: textfield;
    }


</style>